import React from 'react';
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Table from '../layout/table.jsx'
import moment from 'moment'
import { debounce } from 'lodash'
import SmartPlayTag from '../layout/SmartPlayTag/index.jsx';
import { toast } from "react-toastify";
import Helpers from '../../services/helpers.jsx';

class CampaignList extends React.Component {
	constructor(props) {
		super(props)

		const columns = [
			{
				label: 'Campaign name',
				key: 'name',
				canSort: true,
				onSortClick: column => this.onSort(column.key),
				view: (field, entity) => {
					return (
					<div style={{display: "flex", alignItems: "center"}}>
						<div>{field}</div>
						{entity?.hasSmartPlay && <SmartPlayTag marginLeft={6}/>}
					</div>
					)
				}
			},
			{
				label: 'Client',
				key: 'client',
				view: (field) => {
					if (this.state.clientIndex.indexOf(field) !== -1) {
						return this.state.clients[this.state.clientIndex.indexOf(field)].name
					}
					return "???"
				}
			},
			{
				label: 'Duration',
				key: 'infinite',
				view: (field, entity) => {
					return field === true ? 'Infinite' : moment(entity.startDate).format('L') + ' - ' + moment(entity.endDate).format('L')
				}
			},
			{
				label: 'Status',
				key: 'status',
				view: field => {
					return <div style={{color: Helpers.CAMPAIGN_STATUS_MAP[field]?.labelColor}}>{Helpers.CAMPAIGN_STATUS_MAP[field]?.label}</div>
				},
				canSort: true,
				onSortClick: column => this.onSort(column.key)
			},
			{
				label: 'Devices',
				key: 'devices',
				view: function(field) {
					return field.length
				}
			},
			{
				label: 'Priority',
				key: 'priority',
				canSort: true,
				onSortClick: column => this.onSort(column.key)
			},
			{
				label: 'Last update',
				key: 'lastUpdatedAt',
				view: function(field){
					if(field){
						return moment(field).format('l')
					}
					return '-'
				},
				canSort: true,
				onSortClick: column => this.onSort(column.key)
			},
			{
				label: "Update by",
				key: 'nextUpdateBy',
				view: function(field){
					if(field){
						const value = moment(field).format('l');
						const passed = moment(field).isSameOrBefore(moment());
						return passed ? <div className='red'>{value}</div> : value
					}
					return '-'
				},
				canSort: true,
				onSortClick: column => this.onSort(column.key),
			},
			{
				action: "copy",
				hidden: !Helpers.checkPermissions('campaigns:edit'),
				onClick: (id, _, entity) => {
					const clientName = this.state.clients[this.state.clientIndex.indexOf(entity?.client)].name
					var r = window.confirm(`Are you sure you want to DUPLICATE campaign ${entity?.name} for Client ${clientName}`);
					if(r === false) return
					window.open(`/clients/${entity.client}/campaigns/new?copyFrom=${id}&from=campaigns`)
				}
			},
		];
		if (Helpers.checkPermissions('campaigns:delete')) {
			columns.push({
				action: 'delete',
				onClick: (id, key) => {
					var r = window.confirm("Are you sure you want to delete?");
					if (r === false) return
					API.delete('campaigns', id).then(() => {
						let campaigns = [...this.state.campaigns.entities]
						campaigns.splice(key, 1)
						this.setState({ campaigns: { ...this.state.campaigns, entities: campaigns } })
						toast.success('Campaign was successfully deleted');
					})
				}
			});
		}

		this.state = {
			clients: [],
			filters: {},
			sort: ['updatedAt', 'DESC'],
			clientIndex: [],
			selectedClient: null,
			loading: true,
			campaigns: {
				columns,
				entities: [],
				filters: [
				{
					label: 'Search for a campaign',
					onChange: debounce(value => {
						if(value !== this.state.filters.name){
							const newFilter = Helpers.cleanObject({ ...this.state.filters, q: value});
							this.setState({ filters: newFilter}, () => {
								this.loadEntities()
							})
						}
					}, 500)
				},
				{
					label: 'Search for a client',
					isClearable: true,
					placeholder: 'Search client',
					type: 'select',
					value: null,
					entities: [],
					onChange: value => {
						if(value !== this.state.filters.client){
							const newFilter = Helpers.cleanObject({ ...this.state.filters, client: value ? value.id : '' });
							this.setState({ filters: newFilter, campaigns: { ...this.state.campaigns, filters: [this.state.campaigns.filters[0], { ...this.state.campaigns.filters[1], value: value }, this.state.campaigns.filters[2], this.state.campaigns.filters[3]]}}, () => {
								this.loadEntities()
							})
						}
					}
				},
				{
					label: 'Filter status',
					type: 'select',
					isClearable: true,
					placeholder: 'Select status',
					value: null,
					entities: Helpers.getCampaignStatusOptions(),
					onChange: value => {
						if(value !== this.state.filters.status){
							const newFilter = Helpers.cleanObject({...this.state.filters, status: value ? value.id : ''});
							this.setState({ filters: newFilter, campaigns: { ...this.state.campaigns, filters: [this.state.campaigns.filters[0], this.state.campaigns.filters[1], {...this.state.campaigns.filters[2], value: value}, this.state.campaigns.filters[3]]}}, () => {
								this.loadEntities()
							})
						}
					}
				},
				{
					label: 'Select Smartplay',
					type: 'select',
					isClearable: true,
					placeholder: 'Select smartplay',
					value: null,
					entities: [{id: true, name: 'Yes'}, {id: false, name: 'No'}],
					onChange: value => {
						if(value !== this.state.filters.hasSmartPlay) {
							const newFilter = Helpers.cleanObject({...this.state.filters, hasSmartPlay: value ? value.id : ''});
							this.setState({ filters: newFilter, campaigns: { ...this.state.campaigns, filters: [this.state.campaigns.filters[0], this.state.campaigns.filters[1], this.state.campaigns.filters[2], {...this.state.campaigns.filters[3], value: value}]}}, () => {
								this.loadEntities()
							})
						}
					}
				}
				],
				actions: [],
				selectedItems: [],
				multiSelect: false,
				onRowClick: (entity) => {
					if (
						Helpers.checkPermissions(
							["campaigns:details", "campaigns:edit"],
							true
						)
					) {
						this.props.history.push('/campaigns/' + entity.id)
					}
				}
			}
		}
	}

	async componentDidMount() {
		let clientsRaw = await API.getAvaliableOptions("clients");
		let clients = clientsRaw?.clients || [];
		clients = [...(clients || [])].sort(Helpers.caseInsensitiveAlphabeticalOrder);
		clients = clients?.sort(Helpers.caseInsensitiveAlphabeticalOrder)
		let clientIndex = clients.map(client => client.id)
		this.setState({ clients: clients, clientIndex: clientIndex, campaigns: { ...this.state.campaigns, filters: [this.state.campaigns.filters[0], { ...this.state.campaigns.filters[1], entities: clients }, this.state.campaigns.filters[2], this.state.campaigns.filters[3]] } }, () => {
			this.loadEntities()
		})
	}

	onSort(key){
		const newSort = this.state?.sort?.[0] === key ? 
		this.state?.sort?.[1] === "ASC" ? [key, 'DESC'] : [key, 'ASC'] 
		: [key, 'ASC'];
		this.setState({
			sort: newSort
		}, () => {
			this.loadEntities()
		})
	}

	loadEntities() {
		API.getCampaigns(this.state.filters, this.state.sort)
			.then(entities => {
				const filters = [];
				if (entities?.filters?.availableFilters) {
					Helpers.handleFilters(this, filters, entities);
				}

				this.setState({
					...this.state,
					campaigns: {
						...this.state.campaigns,
						filters,
						entities: entities?.data || [],
					},
					loading: false
				})
			})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'Campaigns'} />
				<Content>
					<Table settings={this.state.campaigns} sort={this.state.sort}/>
				</Content>
			</>
	}
}

export default CampaignList;
